function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "baking"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62,51.84v3C62,57.14,48.57,61,32,61S2,57.14,2,54.89v-3c0-6.65,5.06-12.79,13-16.27a58.71,58.71,0,0,1,1,10.17,2,2,0,1,0,4,0,61.11,61.11,0,0,0-1-11.19A42.1,42.1,0,0,1,29,33a51.6,51.6,0,0,1,2,14.77,2,2,0,1,0,4,0A54.37,54.37,0,0,0,33,33c3.8.09,7.51.15,10.82,1.07A56.38,56.38,0,0,1,45,45.74a2,2,0,1,0,4,0,60.47,60.47,0,0,0-1-10.17C56.31,39,62,45,62,51.84Z",
    style: {
      fill: "none",
      stroke: "#1A1F33",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,7.09c0,5.08-4,5.08-4,10.17s4,5.08,4,10.17",
    style: {
      fill: "none",
      stroke: "#1A1F33",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,15.22c0,.5-4,4.32-4,8.14,0,4.08,4,4.07,4,8.14",
    style: {
      fill: "none",
      stroke: "#1A1F33",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,14.21c0,.49-4,4.32-4,8.13,0,4.08,4,4.07,4,8.14",
    style: {
      fill: "none",
      stroke: "#1A1F33",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    x1: 19,
    x2: 20,
    y1: 17.26,
    y2: 18.28
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    x1: 23,
    x2: 24,
    y1: 18.28,
    y2: 17.26
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    x1: 20,
    x2: 19,
    y1: 21.33,
    y2: 22.34
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    x1: 23,
    x2: 24,
    y1: 21.33,
    y2: 22.34
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    x1: 43,
    x2: 44,
    y1: 2,
    y2: 3.02
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    x1: 47,
    x2: 48,
    y1: 3.02,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    x1: 44,
    x2: 43,
    y1: 6.07,
    y2: 7.09
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    x1: 47,
    x2: 48,
    y1: 6.07,
    y2: 7.09
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    x1: 57,
    x2: 58,
    y1: 22.34,
    y2: 23.36
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    x1: 61,
    x2: 62,
    y1: 23.36,
    y2: 22.34
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    x1: 58,
    x2: 57,
    y1: 26.41,
    y2: 27.43
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    x1: 61,
    x2: 62,
    y1: 26.41,
    y2: 27.43
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBread);
export default __webpack_public_path__ + "static/media/bread.50821cff1539ae42afab1a021c7cc899.svg";
export { ForwardRef as ReactComponent };